import { DATA_SOURCES } from '@/config/constants';
import RelatedCategoriesSectionShell from '../RelatedCategoriesTable/RelatedCategoriesSectionShell';

/**
 * Renders the consolidated Related Categories table for an Instagram category
 * or brand surface.
 */
function InstagramRelatedCategoriesSectionTable(props) {
    return (
        <RelatedCategoriesSectionShell
            {...props}
            source={DATA_SOURCES.INSTAGRAM}
        />
    );
}

export default InstagramRelatedCategoriesSectionTable;
